import { setLayoutBehaviors } from "@actions/layout-behaviors-actions";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

export function useSetLayoutBehaviors() {
  const dispatch = useDispatch();

  return useCallback(
    (layoutBehaviors) => {
      dispatch(setLayoutBehaviors(layoutBehaviors));
    },
    [dispatch],
  );
}

export function useLayoutBehaviors() {
  const layoutBehaviors = useSelector((state) => state.layoutBehaviors);
  return layoutBehaviors;
}
